var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoVaiv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 14,
    viewBox: "0 0 61 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1050_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8593 0H12.7395L8.42963 9.42904L4.11972 0H0L6.43634 13.7143H10.4229L16.8593 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9734 13.7143H21.0931L25.403 4.28525L29.7129 13.7143H33.8327L27.3963 0H23.4135L16.9734 13.7143Z",
    fill: "#161C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1906 0H56.0708L51.7571 9.42904L47.451 0H43.3313L49.7676 13.7143H53.7504L60.1906 0Z",
    fill: "#161C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8593 0H12.7395L8.42963 9.42904L4.11972 0H0L6.43634 13.7143H10.4229L16.8593 0Z",
    fill: "#161C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5847 0H36.5791V13.7143H40.5847V0Z",
    fill: "#161C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1050_25"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.1905,
    height: 13.7143,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVaiv);
export default __webpack_public_path__ + "static/media/logo_vaiv.29351ff8522f913df29b62bb57579700.svg";
export { ForwardRef as ReactComponent };